import { render } from "./BookWorkersIndex.vue?vue&type=template&id=719c275e"
import script from "./BookWorkersIndex.vue?vue&type=script&lang=js"
export * from "./BookWorkersIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__